import { useEffect, useState } from "react";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import { db } from "../firebase-config";
import {
  collection,
  getDocs,
  addDoc,
  updateDoc,
  deleteDoc,
  doc,
} from "firebase/firestore";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import Swal from "sweetalert2";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import Modal from "@mui/material/Modal";
import Skeleton from "@mui/material/Skeleton";
import { useAppStore } from "../appStore";
import ViewDetails from "./ViewDetails";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "88%",
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

export default function OrdersList() {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  // const [rows, setRows] = useState([]);
  const rows = useAppStore((state) => state.rows);
  const setRows = useAppStore((state) => state.setRows);
  const empCollectionRef = collection(db, "orders");
  const [formid, setFormid] = useState("");
  const [open, setOpen] = useState(false);
  const [editopen, setEditOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleEditOpen = () => setEditOpen(true);
  const handleClose = () => setOpen(false);
  const handleEditClose = () => setEditOpen(false);

  useEffect(() => {
    getUsers();
  }, []);

  const getUsers = async () => {
    try {
      const data = await getDocs(empCollectionRef);
      const firebaseData = data.docs.map((doc) => ({ ...doc.data(), id: doc.id }));
      
      if (firebaseData.length === 0) {
        const sampleOrders = [
          {
            id: "1",
            email: "john.doe@example.com",
            phone: "1234567890",
            amount: 45.97,
            payment_mode: "Credit Card",
            pincode: "12345",
            address: "123 Main Street, New York, NY",
            items: [
              { name: "Margherita Pizza", price: 12.99, quantity: 2 },
              { name: "Caesar Salad", price: 8.50, quantity: 1 },
              { name: "Chocolate Cake", price: 6.99, quantity: 2 }
            ],
            status: "Delivered",
            orderDate: "2024-01-15"
          },
          {
            id: "2",
            email: "jane.smith@example.com", 
            phone: "9876543210",
            amount: 28.48,
            payment_mode: "PayPal",
            pincode: "67890",
            address: "456 Oak Avenue, Los Angeles, CA",
            items: [
              { name: "Chicken Burger", price: 9.99, quantity: 1 },
              { name: "Grilled Salmon", price: 18.99, quantity: 1 }
            ],
            status: "Processing",
            orderDate: "2024-01-16"
          },
          {
            id: "3",
            email: "mike.johnson@example.com",
            phone: "5555551234",
            amount: 23.98,
            payment_mode: "Cash on Delivery", 
            pincode: "11111",
            address: "789 Pine Road, Chicago, IL",
            items: [
              { name: "Vegetable Pasta", price: 11.99, quantity: 2 }
            ],
            status: "Shipped",
            orderDate: "2024-01-17"
          },
          {
            id: "4",
            email: "sarah.williams@example.com",
            phone: "7777778888",
            amount: 37.97,
            payment_mode: "Debit Card",
            pincode: "22222",
            address: "321 Elm Street, Houston, TX",
            items: [
              { name: "Margherita Pizza", price: 12.99, quantity: 1 },
              { name: "Grilled Salmon", price: 18.99, quantity: 1 },
              { name: "Chocolate Cake", price: 6.99, quantity: 1 }
            ],
            status: "Confirmed",
            orderDate: "2024-01-18"
          },
          {
            id: "5",
            email: "david.brown@example.com",
            phone: "9999990000",
            amount: 17.00,
            payment_mode: "UPI",
            pincode: "33333", 
            address: "654 Cedar Lane, Phoenix, AZ",
            items: [
              { name: "Caesar Salad", price: 8.50, quantity: 2 }
            ],
            status: "Pending",
            orderDate: "2024-01-19"
          }
        ];
        setRows(sampleOrders);
      } else {
        setRows(firebaseData);
      }
    } catch (error) {
      const sampleOrders = [
        {
          id: "1",
          email: "john.doe@example.com",
          phone: "1234567890",
          amount: 45.97,
          payment_mode: "Credit Card",
          pincode: "12345",
          address: "123 Main Street, New York, NY",
          items: [
            { name: "Margherita Pizza", price: 12.99, quantity: 2 },
            { name: "Caesar Salad", price: 8.50, quantity: 1 },
            { name: "Chocolate Cake", price: 6.99, quantity: 2 }
          ],
          status: "Delivered",
          orderDate: "2024-01-15"
        },
        {
          id: "2", 
          email: "jane.smith@example.com",
          phone: "9876543210",
          amount: 28.48,
          payment_mode: "PayPal",
          pincode: "67890",
          address: "456 Oak Avenue, Los Angeles, CA",
          items: [
            { name: "Chicken Burger", price: 9.99, quantity: 1 },
            { name: "Grilled Salmon", price: 18.99, quantity: 1 }
          ],
          status: "Processing", 
          orderDate: "2024-01-16"
        },
        {
          id: "3",
          email: "mike.johnson@example.com",
          phone: "5555551234",
          amount: 23.98,
          payment_mode: "Cash on Delivery",
          pincode: "11111",
          address: "789 Pine Road, Chicago, IL",
          items: [
            { name: "Vegetable Pasta", price: 11.99, quantity: 2 }
          ],
          status: "Shipped",
          orderDate: "2024-01-17"
        },
        {
          id: "4",
          email: "sarah.williams@example.com",
          phone: "7777778888", 
          amount: 37.97,
          payment_mode: "Debit Card",
          pincode: "22222",
          address: "321 Elm Street, Houston, TX",
          items: [
            { name: "Margherita Pizza", price: 12.99, quantity: 1 },
            { name: "Grilled Salmon", price: 18.99, quantity: 1 },
            { name: "Chocolate Cake", price: 6.99, quantity: 1 }
          ],
          status: "Confirmed",
          orderDate: "2024-01-18"
        },
        {
          id: "5",
          email: "david.brown@example.com",
          phone: "9999990000",
          amount: 17.00,
          payment_mode: "UPI",
          pincode: "33333",
          address: "654 Cedar Lane, Phoenix, AZ", 
          items: [
            { name: "Caesar Salad", price: 8.50, quantity: 2 }
          ],
          status: "Pending",
          orderDate: "2024-01-19"
        }
      ];
      setRows(sampleOrders);
    }
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const deleteUser = (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.value) {
        deleteApi(id);
      }
    });
  };

  const deleteApi = async (id) => {
    const userDoc = doc(db, "Menu", id);
    await deleteDoc(userDoc);
    Swal.fire("Deleted!", "Your file has been deleted.", "success");
    getUsers();
  };

  const filterData = (v) => {
    if (v) {
      setRows([v]);
    } else {
      getUsers();
    }
  };

  const editData = (row) => {
    setFormid(row);
    handleEditOpen();
  };

  return (
    <>
      <Modal
        open={editopen}
        onClose={handleEditClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <ViewDetails closeEvent={handleEditClose} fid={formid} />
        </Box>
      </Modal>

      <Paper sx={{ width: "98%", overflow: "hidden", padding: "12px" }}>
        <Typography
          gutterBottom
          variant="h5"
          component="div"
          sx={{ padding: "20px" }}
        >
          Orders List
        </Typography>
        <Divider />
        <Box height={10} />
        <Stack direction="row" spacing={2} className="my-2 mb-2">
          <Autocomplete
            disablePortal
            id="combo-box-demo"
            options={rows}
            sx={{ width: 300 }}
            onChange={(e, v) => filterData(v)}
            getOptionLabel={(rows) => rows.name || ""}
            renderInput={(params) => (
              <TextField {...params} size="small" label="Search Products" />
            )}
          />
          <Typography
            variant="h6"
            component="div"
            sx={{ flexGrow: 1 }}
          ></Typography>
          {/* <Button
            variant="contained"
            endIcon={<AddCircleIcon />}
            onClick={handleOpen}
          >
            Add
          </Button> */}
        </Stack>
        <Box height={10} />
        {rows.length > 0 && (
          <TableContainer>
            <Table stickyHeader aria-label="sticky table">
              <TableHead>
                <TableRow>
                  <TableCell align="left" style={{ minWidth: "100px" }}>
                    Email
                  </TableCell>
                  <TableCell align="left" style={{ minWidth: "100px" }}>
                    Phone
                  </TableCell>
                  <TableCell align="left" style={{ minWidth: "100px" }}>
                    Amount
                  </TableCell>
                  <TableCell align="left" style={{ minWidth: "100px" }}>
                    Payment Mode
                  </TableCell>
                  <TableCell align="left" style={{ minWidth: "100px" }}>
                    Pincode
                  </TableCell>
                  <TableCell align="left" style={{ minWidth: "100px" }}>
                    Address
                  </TableCell>
                  <TableCell align="left" style={{ minWidth: "100px" }}>
                    Details
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {rows
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((row) => {
                    return (
                      <TableRow
                        hover
                        role="checkbox"
                        tabIndex={-1}
                        key={row.code}
                      >
                        <TableCell align="left">{String(row.email)}</TableCell>
                        <TableCell align="left">{String(row.phone)}</TableCell>
                        <TableCell align="left">₹{row.amount}</TableCell>
                        <TableCell align="left">{row.payment_mode}</TableCell>
                        <TableCell align="left">
                          {String(row.pincode)}
                        </TableCell>
                        <TableCell align="left">
                          {String(row.address)}
                        </TableCell>
                        <TableCell align="left">
                          <Button
                            variant="contained"
                            color="success"
                            onClick={() => {
                              editData(row);
                            }}
                          >
                            Deatils
                          </Button>
                          {/* {String(JSON.stringify(row))} */}
                        </TableCell>
                      </TableRow>
                    );
                  })}
              </TableBody>
            </Table>
          </TableContainer>
        )}
        <TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={rows.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Paper>

      {rows.length == 0 && (
        <>
          <Paper sx={{ width: "98%", overflow: "hidden", padding: "12px" }}>
            <Box height={20} />
            <Skeleton variant="rectangular" width={"100%"} height={30} />
            <Box height={40} />
            <Skeleton variant="rectangular" width={"100%"} height={60} />
            <Box height={20} />
            <Skeleton variant="rectangular" width={"100%"} height={60} />
            <Box height={20} />
            <Skeleton variant="rectangular" width={"100%"} height={60} />
            <Box height={20} />
            <Skeleton variant="rectangular" width={"100%"} height={60} />
            <Box height={20} />
            <Skeleton variant="rectangular" width={"100%"} height={60} />
            <Box height={20} />
          </Paper>
        </>
      )}
    </>
  );
}
